import React, { FC, useCallback, useEffect } from 'react'
import { Grid } from '@mui/material'
import { useDispatch } from 'react-redux'
import { FormProvider, useForm } from 'react-hook-form'
import { UpdateGeneralCommissionSettingsRequestDto } from '@sparling/financial-common'
import { classValidatorResolver } from '@hookform/resolvers/class-validator'
import { Modal } from '../../../../components/Modal'
import { InputField } from '../../../../components/InputField'
import { updateGeneralCommissionSettingsRequest } from '../../../../store/actions'

interface GeneralCommissionFeeUpdateModalProps {
  isOpen: boolean
  modalClose: () => void
  defaultValue: number | undefined
}

export const GeneralCommissionFeeUpdateModal: FC<GeneralCommissionFeeUpdateModalProps> = ({
  isOpen,
  modalClose,
  defaultValue,
}) => {
  const dispatch = useDispatch()

  const formMethods = useForm<UpdateGeneralCommissionSettingsRequestDto>({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: classValidatorResolver(UpdateGeneralCommissionSettingsRequestDto),
  })

  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods

  useEffect(() => {
    if (isOpen) {
      reset({
        commissionFee: defaultValue,
      })
    }
  }, [isOpen, defaultValue, reset])

  const onSubmit = useCallback(
    (data) => {
      dispatch(updateGeneralCommissionSettingsRequest(data))
    },
    [dispatch],
  )

  return (
    <Modal
      title={'Update Commission Rate'}
      submitTitle="Update"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitDisabled={!isValid}
      isWidthAuto
    >
      <FormProvider {...formMethods}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <InputField
              inputName={'commissionFee'}
              inputType={'text'}
              labelName={'Commission Rate'}
              fullWidth
              // defaultValue={defaultValue}
            />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}
